import { breakpoints } from './breakpoints';
import { responsiveFontSizes } from '@material-ui/core'

const fontFamily =
	'TT Norms Pro,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol';
const fontWeightBold = 600;
const htmlFontSize = 16;
const pxToRem = (size) => `${size / htmlFontSize}rem`;

export const typographyVariants = {
	h1: {
		fontSize: pxToRem(48),
		fontWeight: fontWeightBold,
		lineHeight: 52 / 48,
	},
	h2: {
		fontSize: pxToRem(32),
		fontWeight: fontWeightBold,
		lineHeight: 36 / 32,
	},
	h3: {
		fontSize: pxToRem(24),
		fontWeight: fontWeightBold,
		lineHeight: 28 / 24,
	},
	h4: {
		fontSize: pxToRem(20),
		fontWeight: fontWeightBold,
		lineHeight: 22 / 20,
	},
	h5: {
		fontSize: pxToRem(18),
		fontWeight: fontWeightBold,
		lineHeight: 20 / 18,
	},
	body1: {
		fontSize: pxToRem(18),
		lineHeight: 24 / 18,
	},
	body2: {
		fontSize: pxToRem(16),
		lineHeight: 22 / 16,
	},
	body3: {
		fontSize: pxToRem(14),
		lineHeight: 20 / 14,
	},
	button: {
		fontSize: pxToRem(18),
		fontWeight: fontWeightBold,
		lineHeight: 24 / 18,
		letterSpacing: 0,
		textTransform: 'none',
	},
	buttonSmall: {
		fontSize: pxToRem(14),
		fontWeight: fontWeightBold,
		lineHeight: 18 / 14,
		letterSpacing: 0,
		textTransform: 'none',

		[breakpoints.up('sm')]: {
			fontSize: pxToRem(14),
		},

		[breakpoints.up('md')]: {
			fontSize: pxToRem(14),
		},
	},
	overline1: {
		fontFamily,
		fontSize: pxToRem(14),
		fontWeight: fontWeightBold,
		lineHeight: 22 / 14,
		textTransform: 'uppercase',
	},
	overline2: {
		fontFamily,
		fontSize: pxToRem(12),
		fontWeight: fontWeightBold,
		lineHeight: 18 / 12,
		textTransform: 'uppercase',
	},
};

export const typography = {
	...typographyVariants,
	fontFamily,
	fontWeightRegular: 400,
	fontWeightBold,
	htmlFontSize,
};

export const withResponsiveTypography = (theme) =>
	responsiveFontSizes(theme, {
		breakpoints: ['sm', 'md'],
		disableAlign: true,
		factor: 2,
		variants: Object.keys(typographyVariants),
	});
